// Preços — extraídos exatamente da tabela original
export const PRICING = {
  "30": {
    duration: "30 minutos",
    avulso: { label: "Avulso", price: 30, unit: "por passeio" },
    semanal: [
      { key: "sem-30-2", label: "Pacote Semanal · 2x/semana", price: 55, unit: "por semana" },
      { key: "sem-30-3", label: "Pacote Semanal · 3x/semana", price: 80, unit: "por semana" },
    ],
    mensal: [
      { key: "men-30-2", label: "Plano Mensal · 2x/semana", price: 210, unit: "por mês" },
      { key: "men-30-3", label: "Plano Mensal · 3x/semana", price: 310, unit: "por mês" },
    ],
  },
  "60": {
    duration: "1 hora",
    avulso: { label: "Avulso", price: 50, unit: "por passeio" },
    semanal: [
      { key: "sem-60-2", label: "Pacote Semanal · 2x/semana", price: 95, unit: "por semana" },
      { key: "sem-60-3", label: "Pacote Semanal · 3x/semana", price: 140, unit: "por semana" },
    ],
    mensal: [
      { key: "men-60-2", label: "Plano Mensal · 2x/semana", price: 360, unit: "por mês" },
      { key: "men-60-3", label: "Plano Mensal · 3x/semana", price: 490, unit: "por mês" },
    ],
  },
};

// flat service list used by the booking form
export const SERVICE_OPTIONS = [
  { value: "avulso-30",   label: "Avulso · 30 min · R$ 30" },
  { value: "avulso-60",   label: "Avulso · 1 hora · R$ 50" },
  { value: "sem-30-2",    label: "Semanal 2x · 30 min · R$ 55/sem" },
  { value: "sem-30-3",    label: "Semanal 3x · 30 min · R$ 80/sem" },
  { value: "sem-60-2",    label: "Semanal 2x · 1 hora · R$ 95/sem" },
  { value: "sem-60-3",    label: "Semanal 3x · 1 hora · R$ 140/sem" },
  { value: "men-30-2",    label: "Mensal 2x · 30 min · R$ 210/mês" },
  { value: "men-30-3",    label: "Mensal 3x · 30 min · R$ 310/mês" },
  { value: "men-60-2",    label: "Mensal 2x · 1 hora · R$ 360/mês" },
  { value: "men-60-3",    label: "Mensal 3x · 1 hora · R$ 490/mês" },
];

export const WHATSAPP_NUMBER = "5513991157896";
export const WHATSAPP_DISPLAY = "(13) 99115-7896";
